<div class="dialog-agent">
  <h1 mat-dialog-title>
    <span>
      {{ 'GLOBAL.REMOVE-PIN-TITLE' | translate }}
    </span>
  </h1>
  <div mat-dialog-content class="">

    <div class="row mx-0 pb-3">
      <div class="col-12 pb-2">
        <p class="m-0">
          {{ 'GLOBAL.REMOVE-PIN-INFO' | translate: { dataalias: data.alias } }}
        </p>
      </div>
      <div class="col-12 py-2">
        <mat-label class="w-100 d-block pb-1 h6">
          {{ 'GLOBAL.CURRENT-CERT-PIN' | translate }}
        </mat-label>
        <mat-form-field class="w-100">
          <input [type]="hidePinCurrent ? 'password' : 'text'" [placeholder]="'GLOBAL.INSERT-CURRENT-PIN' | translate" matInput minlength="4" maxlength="8" autocomplete="new-password" [(ngModel)]="dataCurrentPin" [ngModelOptions]="{standalone: true}" #currentPin="ngModel" />
          <i class="rt-icon pointer fs22 mx-1" matSuffix [attr.data-selenium]="'toggle-pin'" (click)="hidePinCurrent = !hidePinCurrent" [ngClass]="{'rt-view': hidePinCurrent, 'rt-hide': !hidePinCurrent}"></i>
          <mat-hint class="text-danger animated fadeInDown" *ngIf="(currentPin.dirty || currentPin.touched) && currentPin.errors && currentPin.errors.minlength">{{ 'GLOBAL.ERRORS.MINVALUE-INVALID' | translate }}</mat-hint>
        </mat-form-field>
      </div>
  </div>
  <div mat-dialog-actions class="w-100">
    <button mat-raised-button color="primary" class="ms-2 float-end" [disabled]="!(dataCurrentPin)" (click)="sendRemovePIN();">
      <i class="fas fa-spinner fa-pulse fa-1x me-2" *ngIf="sendingInfo"></i>
      <i class="rt-icon rt-comprobado-1" *ngIf="isMobile"></i>
      <span *ngIf="!isMobile">{{ 'GLOBAL.DELETE' | translate }}</span>
    </button>
    <button mat-stroked-button color="primary" class="" [disabled]="sendingInfo" (click)="cancelChanges()">
      <i class="rt-icon rt-cerrar" *ngIf="isMobile"></i>
      <span *ngIf="!isMobile">{{ 'GLOBAL.CANCEL' | translate }}</span>
    </button>
  </div>
</div>
